export default __webpack_public_path__ + "static/media/nav_logo.eb26fcc8.png";